// whyChooseData.js

const whyChooseData = {
  eyebrow: '// Properties In Finite',
  headline_1: 'YOUR DREAM HOUSE IS OUR PRIDE',
  headline_2: 'CUSTOMER SATISFACTION IS OUR PRIORITY',
  cta_label: 'Take Yours',
  cta_url: '/properties',

  stats: [
    { id: 1, label: 'Spacious Life',     value: '2468', suffix: 'sq.ft', desc: 'Maximized space and natural light for a welcoming ambiance.' },
    { id: 2, label: 'Happy Clients',     value: '37',   suffix: 'M',     desc: 'Maximized space and natural light for a welcoming ambiance.' },
    { id: 3, label: 'Listed Properties', value: '697',  suffix: 'k+',    desc: 'Maximized space and natural light for a welcoming ambiance.' },
    { id: 4, label: 'Rated Top',         value: '9',    suffix: '/10',   desc: 'Maximized space and natural light for a welcoming ambiance.' },
  ],

  items: [
    { id: 1, icon: 'verified',       title: 'Verified Properties',   description: 'Every listing is legally verified with clear ownership documents and no hidden disputes.' },
    { id: 2, icon: 'zeroCommission', title: 'Zero Commission',       description: 'No brokerage, no hidden fees. Post and find properties absolutely free of cost.' },
    { id: 3, icon: 'panIndia',       title: 'Pan-India Listings',    description: 'Explore properties across Tamil Nadu, Karnataka, Kerala, Maharashtra and more.' },
    { id: 4, icon: 'secure',         title: 'Secure & Transparent',  description: 'Direct owner connect with full transparency — no middlemen, no surprises.' },
    { id: 5, icon: 'fast',           title: 'Fast Listing',           description: 'List your property in under 5 minutes and reach thousands of buyers instantly.' },
    { id: 6, icon: 'endToEnd',       title: 'End-to-End Support',    description: 'From property search to registration — our team assists at every step.' },
  ],
};

export default whyChooseData;